import styled from 'styled-components';

const StyledSearchFieldRoot = styled.div`
    align-self: center;
    height: fit-content;
    margin-top: 0.5rem;
    position: relative;
`;

export { StyledSearchFieldRoot };
